export class DockThemeModel {
  themeId: string = undefined;
  weight?: number;
  weekNumberDescription: string = undefined;
  icon: string = undefined;   // emoji unicode
  themeName: string = undefined;
  isCurrentTheme: boolean = undefined;
}
